import { Clipboard } from '@angular/cdk/clipboard';
import { Component, OnInit } from '@angular/core';
import { faFacebook, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faLink, faTimes } from '@fortawesome/free-solid-svg-icons';
import { APIWebService } from '@shared/services/api-web.service';
import { SharedModule } from '@shared/shared.module';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  standalone: true,
  selector: 'fc-sharing',
  templateUrl: './fc-sharing.component.html',
  styleUrls: ['./fc-sharing.component.css'],
  imports: [SharedModule],
})
export class FcSharingComponent implements OnInit {
  faTimes = faTimes;
  faFacebook = faFacebook;
  faLink = faLink;
  faWhatsapp = faWhatsapp;

  constructor(
    private apiWebService: APIWebService,
    private ref: DynamicDialogRef,
    private clipboard: Clipboard,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.apiWebService;
  }
  onClose() {
    this.ref.close();
  }

  onShareByFacebook() {
    const quote = 'Beautybook';
    const url = `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}&quote=${quote}`;
    window.open(url, '_blank');
    this.onClose();
  }
  onShareByLink() {
    this.clipboard.copy(window.location.href);
    this.messageService.clear();
    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: 'Link berhasil disalin',
    });
    this.onClose();
  }
}
